module.exports = __webpack_public_path__ + "img/1.e27f59a2.gif";